import { render, staticRenderFns } from "./SuccessLayout.vue?vue&type=template&id=05d52d5a&scoped=true&"
import script from "./SuccessLayout.vue?vue&type=script&lang=js&"
export * from "./SuccessLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d52d5a",
  null
  
)

export default component.exports